import { render, staticRenderFns } from "./Noord-Brabant.vue?vue&type=template&id=093f2a63&"
import script from "./Noord-Brabant.vue?vue&type=script&lang=js&"
export * from "./Noord-Brabant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports